export * from './news-item-bm.model';
